<!-- The frame draws the bar. The notice sits outside the <button> because it can hold a whole form,
     and Chrome turns a Space typed in any field inside a button into a click on that button. -->
<div class="frame" (click)="frameClicked($event)">
  <app-lib-bar>
    <div class="content">
      <app-lib-checkbox [(checked)]="checked" [control]="control()"></app-lib-checkbox>
      <div class="primary-info">
        <h5 class="heading-5 btn-text-action-secondary">{{ titleContent() }}</h5>
        <span class="sub-text text-body-secondary hide-empty text-body-sm">{{ subTitle() }}</span>
        <ng-content></ng-content>
      </div>

    </div>
  </app-lib-bar>
  @if (checked() && (noticeTitle()?.length || noticeContent()?.length || notice())) {
    <div #noticeEl class="notice" fxFlex>
      @if (noticeType() !== 'none') {
        <span>
      @switch (noticeType()) {
        @case ('error') {
          <app-lib-icon name="!" verticalAlign="top" [set]="IconSet.Text" [type]="IconType.Error" [size]="8"></app-lib-icon>
        }
        @case ('warning') {
          <app-lib-icon name="?" verticalAlign="top" [set]="IconSet.Text" [type]="IconType.Warn" [size]="8"></app-lib-icon>
        }
        @case ('info') {
          <app-lib-icon name="+" verticalAlign="top" [set]="IconSet.Text" [type]="IconType.Info" [size]="8"></app-lib-icon>
        }
        @case ('success') {
          <app-lib-icon name="checkmark" verticalAlign="top" [set]="IconSet.Mindpath" [type]="IconType.Success"
                    [size]="8"></app-lib-icon>
        }

      }
    </span>
      }
      @if (noticeTitle()?.length || noticeContent()?.length || notice()) {
        <div class="notice-info">
          <h6 class="heading-6 text-heading-2 hide-empty">{{ noticeTitle() }}</h6>
          <span class="sub-text text-body-secondary hide-empty text-body-sm">
        <ng-content select="[slot='notice-content']">
          <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(noticeContent() ?? '')"></span>
        </ng-content>
            @if (notice(); as noticeContent) {
              <ng-container [ngTemplateOutlet]="noticeContent"></ng-container>
            }
      </span>
        </div>
      }
    </div>
  }
</div>
